import { venueSettingsItems } from 'resources'

export const getAllVenueSettings = (state) =>
  Object.values(state?.VenueSettings?.byName)

export const getVenueSettings = (state) => {
  // get all venue settings names which are displayed on the list on route /venue-settings
  const venueSettingsNames = venueSettingsItems.map(
    (venueSettingsItem) => venueSettingsItem.name
  )

  // get all fetched venue settings
  // it includes settings which are not diplayed on route /venue-settings
  const allVenueSettings = Object.values(
    state?.VenueSettings?.byName ?? []
  )

  // get only those venue settings which should be displayed on route /venue-settings
  const venueSettings = allVenueSettings.filter((venueSetting) =>
    venueSettingsNames.includes(venueSetting.name)
  )

  // when venue settings' value is boolean it is displayed as 'true' or 'false'
  // here we replace those strings to acutal booleans
  // 'true' => true
  // 'false' => false
  return venueSettings.reduce((result, item) => {
    let value

    if (['false', 'true'].includes(item.value)) {
      value = !!(item.value === 'true')
    } else {
      value = item.value
    }

    return { ...result, [item.name]: value }
  }, {})
}

export const getIsVenueSettingsLoading = (state) =>
  state?.VenueSettings?.isLoading ?? false
